<div class="overflow-wrapper">
  <div class="what-is-heading upcoming">
    <div class="content-wrapper">
      <div class="illustration-text-wrapper">
        <h2>{{ 'APPOINTMENT-OVERVIEW.UPCOMING.WHAT-IS' | translate}}</h2>
        <p>{{ 'APPOINTMENT-OVERVIEW.UPCOMING.WHAT-IS-DESCRIPTION' | translate}}</p>
      </div>
    </div>
    <img class="header-illustration" src="/assets/img/illustrations/upcoming.png" alt="">
  </div>
</div>
@if ({upcoming: upcomingAppointments$ | async, isInit: isInit$ | async}; as appointments) {
  @if (appointments?.upcoming?.length > 0) {
    <div class="appointment-info-wrapper">
      @for (appointment of appointments?.upcoming; track appointment) {
        <app-appointment-info
          [appointment]="appointment"
          [appointmentInfoType]="upcomingAppointmentInfoType">
        </app-appointment-info>
      }
    </div>
  }
  @if (!appointments?.upcoming?.length && !appointments.isInit) {
    <div
      class="content-wrapper empty-appointments appointment-overview-wrapper">
      <h3 class="no-appointment-message">{{ 'APPOINTMENT-OVERVIEW.UPCOMING.EMPTY-APPOINTMENTS' | translate }}</h3>
    </div>
  }
}
